export const ContactOfferPage = () => {
    return (
        <main className="layout__content">
            <section className="section layout__section">
                <div className="container">
                    <header className="section__header section__header_left">
                        <h1 className="title title_mobile_sm section__title">Договор оферты</h1>
                    </header>
                    <div className="section__content">
                        <div className="text"><p>Настоящее Пользовательское Соглашение (Далее Соглашение) регулирует
                            отношения между ООО«ВАША ЛАБОРАТОРИЯ» (далее BionMax или Администрация) с одной стороны и
                            пользователем сайта с другой.<br/>
                            Сайт BionMax не является средством массовой информации.</p>
                            <p>Используя сайт, Вы соглашаетесь с условиями данного соглашения.<br/>
                                <b>Если Вы не согласны с условиями данного соглашения, не используйте сайт BionMax!</b>
                            </p>
                            <h3>Предмет соглашения</h3>
                            <p><b>Администрация предоставляет пользователю право на размещение на сайте следующей
                                информации:</b></p>
                            <h3>Предмет соглашения</h3>
                            <p><b>Администрация предоставляет пользователю право на размещение на сайте следующей
                                информации:</b><br/>
                                — Текстовой информации<br/>
                                — Ссылок на материалы, размещенные на других сайтах</p>
                            <h3>Права и обязанности сторон</h3>
                            <p><b>Пользователь имеет право:</b><br/>
                                — осуществлять поиск информации на сайте<br/>
                                — получать информацию на сайте<br/>
                                — создавать информацию для сайта<br/>
                                — требовать от администрации скрытия любой информации о пользователе<br/>
                                — требовать от администрации скрытия любой информации переданной пользователем
                                сайту<br/>
                                — использовать информацию сайта в личных некоммерческих целях</p>
                            <p><b>Администрация имеет право:</b><br/>
                                — по своему усмотрению и необходимости создавать, изменять, отменять правила<br/>
                                — ограничивать доступ к любой информации на сайте<br/>
                                — создавать, изменять, удалять информацию<br/>
                                — удалять учетные записи<br/>
                                — отказывать в регистрации без объяснения причин</p>
                            <p><b>Пользователь обязуется:</b><br/>
                                — обеспечить достоверность предоставляемой информации<br/>
                                — обеспечивать сохранность личных данных от доступа третьих лиц<br/>
                                — обновлять Персональные данные, предоставленные при регистрации, в случае их
                                изменения<br/>
                                — не копировать информацию с других источников<br/>
                                — не нарушать работоспособность сайта<br/>
                                — не регистрировать учетную запись от имени или вместо другого лица за исключением
                                случаев, предусмотренных законодательством РФ<br/>
                                — не размещать материалы рекламного, эротического, порнографического или оскорбительного
                                характера, а также иную информацию, размещение которой запрещено или противоречит нормам
                                действующего законодательства РФ<br/>
                                — не использовать скрипты (программы) для автоматизированного сбора информации и/или
                                взаимодействия с Сайтом и его Сервисами</p>
                            <p><b>Администрация обязуется:</b><br/>
                                — поддерживать работоспособность сайта за исключением случаев, когда это невозможно по
                                независящим от Администрации причинам.</p>
                            <h3>Ответственность сторон</h3>
                            <p>— администрация не несет никакой ответственности за услуги, предоставляемые третьими
                                лицами<br/>
                                — в случае возникновения форс-мажорной ситуации (боевые действия, чрезвычайное
                                положение, стихийное бедствие и т. д.) Администрация не гарантирует сохранность
                                информации, размещённой Пользователем, а также бесперебойную работу информационного
                                ресурса</p>
                            <h3>Условия действия Соглашения</h3>
                            <p>Данное Соглашение вступает в силу при любом использовании данного сайта.<br/>
                                Соглашение перестает действовать при появлении его новой версии.<br/>
                                Администрация оставляет за собой право в одностороннем порядке изменять данное
                                соглашение по своему усмотрению.<br/>
                                Администрация не оповещает пользователей об изменении в Соглашении.</p>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}